// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zxam8q6RZsoDobdb6UHC{margin:0 8px}.R4_tgiA2cMETl66qU2Gz{padding:0 16px}.OkcrWK8gdyE0QXMujdHT{color:var(--content-brand-primary);font-weight:500;text-decoration:none}.OkcrWK8gdyE0QXMujdHT:hover{color:var(--content-brand-secondary);text-decoration:underline}.v8XZTzDEzVMm_N433ndv{flex-direction:column;margin:0 16px;display:flex}.knsx0SIEsigUBL3TCTXi{min-height:72px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `zxam8q6RZsoDobdb6UHC`,
	"kbStep": `R4_tgiA2cMETl66qU2Gz`,
	"learnMoreLink": `OkcrWK8gdyE0QXMujdHT`,
	"descriptionStep": `v8XZTzDEzVMm_N433ndv`,
	"textarea": `knsx0SIEsigUBL3TCTXi`
};
export default ___CSS_LOADER_EXPORT___;
